import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Signatory } from '@shared/models/document/signatory';


import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'ngx-moment';

@Component({
    selector: 'app-info',
    templateUrl: './emailstate.component.html',
    styleUrls: ['./emailstate.component.scss'],
    standalone: true,
    imports: [TranslateModule, MomentModule]
})
export class EmailstateComponent {
    public readonly bsModalRef = inject(BsModalRef);

    get signatory(): Signatory {
        return this._signatory;
    }

    set signatory(value: Signatory) {
        this._signatory = value;
    }

    private _signatory!: Signatory;

    stateClass(state: string) {

        switch (state) {
            case 'SENT': {
                return '';
            }
            case 'BOUNCE':
            case 'SPAMREPORT': {
                return 'text-danger';
            }
            case 'DROPPED':
            case 'PROCESSED':
            case 'OPEN':
            case 'DELIVERED': {
                return 'text-success';
            }
            default: {
                return '';
            }
        }
    }
}
